import React from 'react';

export default function FormatCell({ value }) {
  if (!value || !Array.isArray(value)) return <span />;

  const labels = value.map(item => item.label || '').filter(Boolean);
  return <span>{labels.join(', ')}</span>;
}
